import { swSettings } from "app/common/services/swSettings";
import manageIntegrationsTrackingService from "app/pages/sales-intelligence/modules/manage-integrations/services/tracking";
import { resolveSignalsApiCustomAttributes } from "app/pages/sales-intelligence/modules/management/services/tracking/utils";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import type { SignalsApiStatusResponse } from "app/pages/sales-intelligence/sub-modules/management/types";
import { isNoTouchOrTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

type ManageSignalsWebhookParams = {
    isConfigured: boolean;
    data: SignalsApiStatusResponse | undefined;
};

export const goToSignalsWebhookGateway = (): void => {
    void siNavigator.goToGatewayPage("signalsWebhook");
};

export const manageSignalsWebhook = ({ isConfigured, data }: ManageSignalsWebhookParams): void => {
    manageIntegrationsTrackingService.trackSignalsWebhookClick(resolveSignalsApiCustomAttributes(data));

    if (!isConfigured) {
        goToSignalsWebhookGateway();
        return;
    }

    void siNavigator.goToManagementSignalsApiPage();
};

export const isSignalsRestApiAccountEnabled = (): boolean => !isNoTouchOrTrialOrAfterTrial(swSettings);

export const goToSignalsRestApiGateway = (): void => {
    void siNavigator.goToGatewayPage("signalsRestApi");
};

export const manageSignalsRestApi = (isConfigured: boolean): void => {
    manageIntegrationsTrackingService.trackApiCardClick("signalsRestApi");

    if (!isConfigured) {
        goToSignalsRestApiGateway();
        return;
    }

    void siNavigator.goToManagementSignalsRestApiPage();
};

export const exploreSignalsRestApi = (): void => {
    manageIntegrationsTrackingService.trackApiCardClick("signalsRestApi");
    goToSignalsRestApiGateway();
};
